import { getIcon } from '../utils/getIcon';
export const marketsArray = [
    {
        id: '33',
        symbol: 'USDSUI',
        coinType: '0x44f838219cf67b058f3b37907b655f226153c18e33dfcd0da559a844fea9b1c1::usdsui::USDSUI',
        expo: 6,
        icon: getIcon('usdsui'),
        color: '#ad6d61',
        tokenType: ['stables'],
    },
    {
        id: '6',
        symbol: 'USDC',
        coinType: '0xdba34672e30cb065b1f93e3ab55318768fd6fef66c15942c9f7cb846e2f900e7::usdc::USDC',
        expo: 6,
        icon: getIcon('usdc'),
        color: '#2676ca',
        okxUrl: 'https://web3.okx.com/earn/product/bluefin-sui-usdc-33602#source=activitypage&activitySourcePage=sui',
        tokenType: ['stables'],
    },
    {
        id: '5',
        symbol: 'suiUSDT',
        coinType: '0x375f70cf2ae4c00bf37117d0c85a2c71545e6ee05c4a5c7d282cd66a4504b068::usdt::USDT',
        expo: 6,
        icon: getIcon('suiusdt'),
        color: '#039393',
        tokenType: ['stables'],
    },
    {
        id: '7',
        symbol: 'WAL',
        coinType: '0x356a26eb9e012a68958082340d4c4116e7f55615cf27affcff209cf0ae544f59::wal::WAL',
        expo: 9,
        icon: getIcon('wal'),
        color: '#98f0e5',
    },
    {
        id: '11',
        symbol: 'DEEP',
        coinType: '0xdeeb7a4662eec9f2f3def03fb937a663dddaa2e215b8078a284d026b7946c270::deep::DEEP',
        expo: 6,
        icon: getIcon('deep'),
        color: '#1449ec',
    },
    {
        id: '2',
        symbol: 'stSUI',
        coinType: '0xd1b72982e40348d069bb1ff701e634c117bb5f741f44dff91e472d3b01461e55::stsui::STSUI',
        expo: 9,
        icon: getIcon('stsui'),
        color: '#baadfb',
        tokenType: ['sui'],
    },
    {
        id: '1',
        symbol: 'SUI',
        coinType: '0x2::sui::SUI',
        expo: 9,
        icon: getIcon('sui'),
        color: '#4da2ff',
        tokenType: ['sui'],
    },
    {
        id: '31',
        symbol: 'suiUSDe',
        coinType: '0x41d587e5336f1c86cad50d38a7136db99333bb9bda91cea4ba69115defeb1402::sui_usde::SUI_USDE',
        expo: 6,
        icon: getIcon('suiusde'),
        color: '#ad6d61',
        retired: true,
        tokenType: ['stables'],
    },
    {
        id: '32',
        symbol: 'dbUSDC',
        coinType: '0x66a09a4da70828bfa1ffb98998477403e4fc47ffa727adb916bb42d9bc8e1d66::alphalend_deepbook_pool::DEEPBOOK_STAKED<0xdba34672e30cb065b1f93e3ab55318768fd6fef66c15942c9f7cb846e2f900e7::usdc::USDC>',
        expo: 6,
        icon: getIcon('dbusdc'),
        color: '#ad6d61',
        retired: true,
        tokenType: ['stables', 'deepbook'],
    },
    {
        id: '35',
        symbol: 'dbUSDSUI',
        coinType: '0x66a09a4da70828bfa1ffb98998477403e4fc47ffa727adb916bb42d9bc8e1d66::alphalend_deepbook_pool::DEEPBOOK_STAKED<0x44f838219cf67b058f3b37907b655f226153c18e33dfcd0da559a844fea9b1c1::usdsui::USDSUI>',
        expo: 6,
        icon: getIcon('dbusdsui'),
        color: '#ad6d61',
        retired: true,
        tokenType: ['stables', 'deepbook'],
    },
    {
        id: '18',
        symbol: 'XAUm',
        coinType: '0x9d297676e7a4b771ab023291377b2adfaa4938fb9080b8d12430e4b108b836a9::xaum::XAUM',
        expo: 9,
        icon: getIcon('xaum'),
        color: '#e6b92b',
    },
    {
        id: '29',
        symbol: 'WBTC',
        coinType: '0x0041f9f9344cac094454cd574e333c4fdb132d7bcc9379bcd4aab485b2a63942::wbtc::WBTC',
        expo: 8,
        icon: getIcon('wbtc'),
        color: '#2665a8',
        tag: 'LayerZero',
        tagVariant: 'info',
        tokenType: ['btc'],
    },
    {
        id: '3',
        symbol: 'wBTC',
        coinType: '0xaafb102dd0902f5055cadecd687fb5b71ca82ef0e0285d90afde828ec58ca96b::btc::BTC',
        expo: 8,
        icon: getIcon('wbtc'),
        color: '#2665a8',
        retired: true,
        tokenType: ['btc'],
    },
    {
        id: '16',
        symbol: 'xBTC',
        coinType: '0x876a4b7bce8aeaef60464c11f4026903e9afacab79b9b142686158aa86560b50::xbtc::XBTC',
        expo: 8,
        icon: getIcon('xbtc'),
        color: '#000000',
        okxUrl: 'https://web3.okx.com/earn/product/bluefin-sui-xbtc-33513#source=activitypage&activitySourcePage=sui',
        tokenType: ['btc'],
    },
    {
        id: '14',
        symbol: 'tBTC',
        coinType: '0x77045f1b9f811a7a8fb9ebd085b5b0c55c5cb0d1520ff55f7037f89b5da9f5f1::TBTC::TBTC',
        expo: 8,
        icon: getIcon('tbtc'),
        color: '#1d2229',
        tokenType: ['btc'],
    },
    {
        id: '10',
        symbol: 'suiETH',
        coinType: '0xd0e89b2af5e4910726fbcd8b8dd37bb79b29e5f83f7491bca830e94f7f226d29::eth::ETH',
        expo: 8,
        icon: getIcon('suieth'),
        color: '#a0cff5',
        tokenType: [],
    },
    {
        id: '28',
        symbol: 'SOL',
        coinType: '0xb7844e289a8410e50fb3ca48d69eb9cf29e27d223ef90353fe1bd8e27ff8f3f8::coin::COIN',
        expo: 8,
        icon: getIcon('sol'),
        color: '#ad6d61',
    },
    {
        id: '4',
        symbol: 'LBTC',
        coinType: '0x3e8e9423d80e1774a7ca128fccd8bf5f1f7753be658c5e645929037f7c819040::lbtc::LBTC',
        expo: 8,
        icon: getIcon('lbtc'),
        color: '#356661',
        retired: true,
        tokenType: ['btc'],
    },
    {
        id: '9',
        symbol: 'BLUE',
        coinType: '0xe1b45a0e641b9955a20aa0ad1c1f4ad86aad8afb07296d4085e349a50e90bdca::blue::BLUE',
        expo: 9,
        icon: getIcon('blue'),
        color: '#2a5ada',
        isolated: true,
    },
    {
        id: '21',
        symbol: 'eSUI',
        coinType: '0x66629328922d609cf15af779719e248ae0e63fe0b9d9739623f763b33a9c97da::esui::ESUI',
        expo: 9,
        icon: getIcon('esui'),
        color: '#c0e5ff',
        ember: true,
        tokenType: ['sui', 'ember'],
    },
    {
        id: '26',
        symbol: 'eWAL',
        coinType: '0x8a398f65f8635be31c181632bf730aea25074505d70c77d9b287e7d4f063ef70::ewal::EWAL',
        expo: 9,
        icon: getIcon('ewal'),
        color: '#ad6d61',
        retired: true,
        tokenType: ['ember'],
    },
    {
        id: '23',
        symbol: 'eTHIRD',
        coinType: '0x89b0d4407f17cc1b1294464f28e176e29816a40612f7a553313ea0a797a5f803::ethird::ETHIRD',
        expo: 6,
        icon: getIcon('ethird'),
        color: '#ad6d61',
        retired: true,
        tokenType: ['ember'],
    },
    {
        id: '24',
        symbol: 'exBTC',
        coinType: '0x56589f5381303a763a62e79ac118e5242f83652f4c5a9448af75162d8cb7140c::exbtc::EXBTC',
        expo: 8,
        icon: getIcon('exbtc'),
        color: '#c0e5ff',
        retired: true,
        tokenType: ['btc', 'ember'],
    },
    {
        id: '22',
        symbol: 'egUSDC',
        coinType: '0x68532559a19101b58757012207d82328e75fde7a696d20a59e8307c1a7f42ad7::egusdc::EGUSDC',
        expo: 6,
        icon: getIcon('egusdc'),
        color: '#ad6d61',
        ember: true,
        tokenType: ['stables', 'ember'],
    },
    {
        id: '20',
        symbol: 'eBTC',
        coinType: '0x244b98d29bd0bba401c7cfdd89f017c51759dad615e15a872ddfe45af079bb1d::ebtc::EBTC',
        expo: 8,
        icon: getIcon('ebtc'),
        color: '#dd7362',
        retired: true,
        tokenType: ['btc', 'ember'],
    },
    {
        id: '34',
        symbol: 'eEARN',
        coinType: '0x34469c8accdd673df02600265cbbad3688577f0e716866e257f88d448d463492::eearn::EEARN',
        expo: 6,
        icon: getIcon('eearn'),
        color: '#ad6d61',
        ember: true,
        tokenType: ['ember'],
    },
    {
        id: '36',
        symbol: 'HIGH',
        coinType: '0x97b0ecdd2051cf7349864ee32aea7498923a3d5f8d102bcfd4939eb206c88059::high::HIGH',
        expo: 6,
        icon: getIcon('high'),
        color: '#9c63a6',
        ember: true,
        tokenType: ['ember'],
    },
    {
        id: '13',
        symbol: 'DMC',
        coinType: '0x4c981f3ff786cdb9e514da897ab8a953647dae2ace9679e8358eec1e3e8871ac::dmc::DMC',
        expo: 9,
        icon: getIcon('dmc'),
        color: '#000000',
        isolated: true,
    },
    {
        id: '12',
        symbol: 'ALPHA',
        coinType: '0xfe3afec26c59e874f3c1d60b8203cb3852d2bb2aa415df9548b8d688e6683f93::alpha::ALPHA',
        expo: 9,
        icon: getIcon('alpha'),
        color: '#2d9eff',
        retired: true,
        active: false,
    },
    {
        id: '17',
        symbol: 'ALKIMI',
        coinType: '0x1a8f4bc33f8ef7fbc851f156857aa65d397a6a6fd27a7ac2ca717b51f2fd9489::alkimi::ALKIMI',
        expo: 9,
        icon: getIcon('alkimi'),
        color: '#2f3392',
        retired: true,
    },
    {
        id: '19',
        symbol: 'UP',
        coinType: '0x87dfe1248a1dc4ce473bd9cb2937d66cdc6c30fee63f3fe0dbb55c7a09d35dec::up::UP',
        expo: 6,
        icon: getIcon('up'),
        color: '#c7ff51',
        retired: true,
    },
    {
        id: '25',
        symbol: 'sdeUSD',
        coinType: '0xf6b468748dced8435f4407d0ecb0457b921a2e89266a60862e36dbf243c71841::sdeusd::SDEUSD',
        expo: 6,
        icon: getIcon('sdeusd'),
        color: '#ad6d61',
        active: false,
        tokenType: ['stables'],
    },
    {
        id: '15',
        symbol: 'IKA',
        coinType: '0x7262fb2f7a3a14c888c438a3cd9b912469a58cf60f367352c46584262e8299aa::ika::IKA',
        expo: 9,
        icon: getIcon('ika'),
        color: '#ee2c5b',
    },
    {
        id: '30',
        symbol: 'BTCvc',
        coinType: '0xd8fe9619ff2bcef53e0330b83b31ab380a04ee787dafecc19aac365a9824517f::btcvc::BTCVC',
        expo: 8,
        icon: getIcon('btcvc'),
        color: '#2665a8',
        isolated: true,
        tokenType: ['btc'],
    },
];
export const oraclePriceOverrides = {
    suiUSDT: 'USDT',
    suiETH: 'ETH',
    wBTC: 'BTC',
    LBTC: 'BTC',
    tBTC: 'BTC',
    xBTC: 'BTC',
    BTCVC: 'BTC',
    eWAL: 'WAL',
    dbUSDC: 'USDC',
    USDSUI: 'USDC',
    eEARN: 'USDC',
    ALPHA: null, // No oracle price feed
};
export const getOraclePriceLink = (tokenSymbol) => {
    const overrideValue = oraclePriceOverrides[tokenSymbol];
    const tokenForOracle = overrideValue !== null && overrideValue !== void 0 ? overrideValue : (overrideValue === null ? null : tokenSymbol.toUpperCase());
    if (!tokenForOracle) {
        return undefined;
    }
    // Tokens that require '.RR' suffix in the Pyth price feed URL
    const tokensWithRRSuffix = ['XAUM', 'EBTC', 'EGUSDC', 'ESUI', 'ETHIRD', 'EXBTC'];
    const shouldAddRR = tokensWithRRSuffix.includes(tokenForOracle);
    // Tokens whose Pyth feed lives under the 'Crypto.Index.' namespace
    const tokensWithIndexPrefix = ['HIGH'];
    const prefix = tokensWithIndexPrefix.includes(tokenForOracle) ? 'Crypto.Index.' : 'Crypto.';
    return `https://insights.pyth.network/price-feeds/${prefix}${tokenForOracle}%2FUSD${shouldAddRR ? '.RR' : ''}`;
};
export const getTokenInfo = () => {
    const base = marketsArray.reduce((acc, { coinType, symbol }) => {
        acc[coinType] = symbol;
        return acc;
    }, {});
    return Object.assign({}, base);
};
export const getTokenIcon = () => {
    const base = marketsArray.reduce((acc, { coinType, icon }) => {
        acc[coinType] = icon;
        return acc;
    }, {});
    return Object.assign({}, base);
};
// Check if a market is active
// If the market's active field is undefined or true, it's considered active
export const isMarketActive = (marketId) => {
    const market = marketsArray.find((m) => m.id === marketId);
    return (market === null || market === void 0 ? void 0 : market.active) !== false;
};
// Check if market is retired
export const isMarketRetired = (marketId) => {
    const market = marketsArray.find((m) => m.id === marketId);
    return (market === null || market === void 0 ? void 0 : market.retired) === true;
};
// Get only active markets as an array
export const getActiveMarkets = () => {
    return marketsArray.filter((market) => market.active !== false);
};
// Get non-retired markets for new supply/borrow
export const getNonRetiredMarkets = () => {
    return marketsArray.filter((market) => market.active !== false && market.retired !== true);
};
// Get retired markets (for retired section)
export const getRetiredMarkets = () => {
    return marketsArray.filter((market) => market.active !== false && market.retired === true);
};
// Get market by ID
export const getMarketById = (marketId) => {
    return marketsArray.find((m) => m.id === marketId);
};
// Get token color by symbol or market ID
export const getTokenColor = (tokenSymbol, marketId) => {
    // First try to find by market ID if provided
    if (marketId) {
        const marketById = marketsArray.find((m) => m.id === marketId);
        if (marketById === null || marketById === void 0 ? void 0 : marketById.color) {
            return marketById.color;
        }
    }
    // Then try to find by symbol
    const marketBySymbol = marketsArray.find((m) => m.symbol.toLowerCase() === tokenSymbol.toLowerCase());
    if (marketBySymbol === null || marketBySymbol === void 0 ? void 0 : marketBySymbol.color) {
        return marketBySymbol.color;
    }
    // Fallback colors for unknown tokens
    const fallbackColors = [
        '#2B4DED', // Blue
        '#10B981', // Green
        '#F59E0B', // Amber
        '#EF4444', // Red
        '#8B5CF6', // Purple
        '#FFD1A7', // Orange
        '#7EC8FF', // Cyan
        '#84CC16', // Lime
    ];
    // Use a simple hash of the symbol to get consistent colors
    let hash = 0;
    for (let i = 0; i < tokenSymbol.length; i++) {
        hash = ((hash << 5) - hash + tokenSymbol.charCodeAt(i)) & 0xffffffff;
    }
    return fallbackColors[Math.abs(hash) % fallbackColors.length];
};
